import React from "react";
import NavButton from "../../components/NavButton/index";
import ContentHeader from "../../components/ContentHeader/index";
import Divider from "../../components/Divider/index";
import { Actions } from "../../reducers/Context";

const TeamOrMember = (props) => {
  return (
    <div className="afs-msm-stage-content add-all-padding fx-container-y align-centre justify-centre">
      <ContentHeader text="Please choose an option" />
      <NavButton
        className="afs-msm-inline-button btn"
        text="I WANT TO CREATE A NEW TEAM"
        actionType={Actions.SELECTED_TEAM_ADMIN}
        payload={{ toStage: "signup-method" }}
      />
      <p>Select this option if you are a team admin and want to set up a new team on TeamStats</p>
      <Divider text="Or" />

      <NavButton
        className="afs-msm-inline-button btn"
        text="MY TEAM ALREADY USES TEAMSTATS"
        actionType={Actions.SELECTED_TEAM_MEMBER}
        payload={{ toStage: "email-form" }}
      />

      <p>Select this option if you want to be added to a team that is already registered on TeamStats</p>
    </div>
  );
};

export default {
  id: "team-or-member",
  title: "Sign up to TeamStats",
  subtitles: ["Free to join and use.", "No payment details required."],
  imageUrl: "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-2.jpg",
  component: TeamOrMember,
  buttons: [],
};
